import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=3338e202&scoped=true&lang=pug&"
import script from "./Step1.vue?vue&type=script&lang=js&"
export * from "./Step1.vue?vue&type=script&lang=js&"
import style0 from "../Onboarding.scss?vue&type=style&index=0&id=3338e202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3338e202",
  null
  
)

export default component.exports